import React, { useCallback } from 'react';
import styled from 'styled-components';
import type { EpiDocumentType, EpiSectionNode } from '../types/types';
import { useEpiContext } from '../context/EpiContext';
import EpiMenu from './EpiMenu';

interface IProps {
  docType: EpiDocumentType;
}

const EpiSidebar: React.FC<IProps> = ({ docType }) => {
  const { visibleCompositions, setSelectedComposition, setSelectedSection } =
    useEpiContext();

  const handleClickSelected = useCallback(
    (node: EpiSectionNode, compId: string) => {
      setSelectedComposition(compId);
      setSelectedSection(node);
    },
    [setSelectedComposition, setSelectedSection]
  );

  return (
    <Sidebar>
      <EpiMenu
        onClick={handleClickSelected}
        docType={docType}
        compositions={visibleCompositions}
      />
    </Sidebar>
  );
};

export default EpiSidebar;

const Sidebar = styled.div`
  min-width: 380px;
  max-width: 380px;
`;
